import { Link } from "react-router-dom";
import iconSprite from "../svg/sprite.svg";
import { useEffect, useState, useContext } from "react";
import { Context } from "../App";
import { jwtDecode } from "jwt-decode";
import Cookies from "universal-cookie";
import Repo from "../Api_backend/Repo";

function Header(props) {
  const [isNavCollapsableOpen, setisNavCollapsableOpen] = useState(false);

  const toggleNavCollapsable = () => {
    setisNavCollapsableOpen(!isNavCollapsableOpen);
  };
  const [ruolo, setRuolo] = useState("noLoggin");
  const { apiToken } = useContext(Context);
  const cookies = new Cookies();

  var decoded = "";
  if (apiToken) {
    decoded = jwtDecode(String(apiToken));
  }

  useEffect(() => {
    if (props.dataStruttura) {
      setRuolo("struttura");
    }
  }, [props.dataStruttura]);

  useEffect(() => {
    if (apiToken) {
      if (decoded.role == "USER") {
        setRuolo("responsabilePOI");
      } else {
        setRuolo("operatore");
      }
    }
  }, [apiToken]);

  const handleLogout = () => {
    localStorage.clear();
    cookies.remove("token_key");
    window.location.href = props.subfolder + "/";
  };

  const handleDownloadManuale = () => {
    Repo.downloadManuale()
      .then((response) => {
        if (response.status == 200) {
          const { fileContent, fileName } = response.data;
          const binaryString = window.atob(fileContent);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: "application/pdf" });

          // Crea un URL temporaneo per il blob
          const imageUrl = URL.createObjectURL(blob);

          // Crea un elemento <a> con l'URL temporaneo e l'attributo download
          const link = document.createElement("a");
          link.href = imageUrl;
          link.download = fileName; // Nome del file
          link.click();

          // Rilascia l'URL temporaneo dopo il click
          URL.revokeObjectURL(imageUrl);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <header className="it-header-wrapper ">
      <div className="it-header-slim-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="it-header-slim-wrapper-content">
                <a
                  className="d-lg-block navbar-brand"
                  target="_blank"
                  href="https://www.servizilocalispa.it"
                  aria-label="Vai al portale di  - link esterno - apertura nuova scheda"
                  title="Vai al portale "
                >
                  Servizi Locali Spa
                </a>
                {ruolo == "struttura" ||
                ruolo == "responsabilePOI" ||
                ruolo == "operatore" ? (
                  <div className="it-header-slim-right-zone">
                    <a
                      className="btn btn-primary-header btn-icon btn-full mx-0"
                      onClick={handleDownloadManuale}
                      title="Scarica manuale"
                    >
                      <span className="d-lg-block">Scarica manuale</span>
                    </a>
                    <div className="it-access-top-wrapper me-2">
                      <a
                        className="btn btn-primary-header btn-icon btn-full mx-0"
                        onClick={handleLogout}
                      >
                        <span className="d-lg-block">Esci</span>
                      </a>
                    </div>
                    <div className="it-user-wrapper nav-item dropdown">
                      {/* Il tuo codice per il dropdown con il nome utente e altre opzioni */}
                      <>
                        <div className="it-user-wrapper nav-item dropdown">
                          <Link
                            to="/#"
                            className="btn btn-icon btn-full"
                            data-bs-toggle="dropdown"
                            // aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <span className="rounded-icon">
                              <svg className="icon icon-primary ms-0">
                                <use href={`${iconSprite}#it-user`} />
                              </svg>
                            </span>
                            <span className="d-none d-lg-block">
                              {decoded.FiscalCode
                                ? decoded.FiscalCode
                                : localStorage.getItem("savedDataCF")}
                            </span>
                          </Link>
                          <div
                            className="dropdown-menu"
                            x-placement="bottom-start"
                            style={{
                              position: "absolute",
                              willChange: "transform",
                              top: "0px",
                              left: "0px",
                              transform: "translate3d(0px, 48px, 0px)",
                            }}
                          >
                            <div className="link-list-wrapper">
                              <ul className="link-list">
                                <li>
                                  <a className="list-item text-decoration-none">
                                    <svg className="icon icon-primary">
                                      <use
                                        xlinkHref={`${iconSprite}#it-external-link`}
                                      ></use>
                                    </svg>

                                    <span
                                      className="ms-1 text-decoration-none"
                                      onClick={handleLogout}
                                    >
                                      <b>Esci</b>
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                ) : (
                  <div className="it-header-slim-right-zone">
                    <div className="it-access-top-wrapper me-2">
                      <a
                        className="btn btn-primary-header btn-icon btn-full mx-0"
                        href="https://otranto.servizilocalispa.it/TouristCard.Portal/"
                      >
                        <span className=" d-lg-block">Accedi</span>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-nav-wrapper">
        <div className="it-header-center-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="it-header-center-content-wrapper">
                  <div className="it-brand-wrapper">
                    <a title="Vai alla homepage">
                      <svg className="icon">
                        <use href={`${iconSprite}#it-pa`} />
                      </svg>
                      <div className="it-brand-text">
                        <div className="it-brand-title ms-2">Otranto Card</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-header-navbar-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav
                className="navbar navbar-expand-lg has-megamenu"
                aria-label="Navigazione principale"
              >
                <button
                  className="custom-navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded={isNavCollapsableOpen}
                  aria-label="Mostra/Nascondi la navigazione"
                  onClick={toggleNavCollapsable}
                >
                  <svg className="icon">
                    {" "}
                    <use href={`${iconSprite}#it-burger`} />{" "}
                  </svg>
                </button>
                <div
                  className={`navbar-collapsable ${
                    isNavCollapsableOpen ? "expanded" : ""
                  }`}
                  id="navbarNav"
                  style={{ display: isNavCollapsableOpen ? "block" : "none" }}
                >
                  <div
                    className={`overlay fade ${
                      isNavCollapsableOpen ? "show" : ""
                    }`}
                    style={{ display: isNavCollapsableOpen ? "block" : "none" }}
                  ></div>
                  <div className="close-div">
                    <button
                      className="btn close-menu"
                      type="button"
                      onClick={toggleNavCollapsable}
                    >
                      <span className="visually-hidden">
                        Nascondi la navigazione
                      </span>
                      <svg className="icon">
                        <use href={`${iconSprite}#it-close-big`} />
                      </svg>
                    </button>
                  </div>

                  <div className="menu-wrapper">
                    <ul className="navbar-nav">
                      {ruolo == "struttura" ? (
                        <>
                          <li className="nav-item ">
                            <Link className="nav-link" to="/">
                              <span>Home</span>
                            </Link>
                          </li>
                          <li className="nav-item ">
                            <Link className="nav-link " to="/touristcard">
                              <span>Rilascio Nuova Card</span>
                            </Link>
                          </li>
                          <li className="nav-item ">
                            <Link className="nav-link " to="/cronologia">
                              <span>Gestione Card Emesse</span>
                            </Link>
                          </li>
                        </>
                      ) : ruolo == "responsabilePOI" ? (
                        <>
                          <li className="nav-item">
                            <Link className="nav-link" to="/scansione">
                              <span>Scansione</span>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className="nav-link" to="/cronologiaScan">
                              <span>Cronologia scansioni</span>
                            </Link>
                          </li>
                        </>
                      ) : ruolo == "operatore" ? (
                        <>
                          <li className="nav-item">
                            <Link className="nav-link" to="/Home">
                              <span>Home</span>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className="nav-link" to="/statistiche">
                              <span>Statistiche</span>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className="nav-link" to="/validazionePOI">
                              <span>Validazione POI</span>
                            </Link>
                          </li>
                        </>
                      ) : (
                        <>
                          {/*<li className="nav-item">
                            <Link className="nav-link" to="/login">
                              <span>LOGIN</span>
                            </Link>
                          </li>*/}
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
